import React from 'react';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import './App.css';
import 'antd/dist/antd.css';

import { AuthProvider } from './contexts/auth';
import WithAxios from './contexts/WithAxios';
import Routes from './Routes';

function App() {
  return (
    <AuthProvider>
      <WithAxios>
        <Router>
          <Switch>
            <Routes />
          </Switch>
        </Router>
      </WithAxios>
    </AuthProvider>
  );
}

export default App;
